<template>
 
	<PuSkeleton  v-if="storeLoader == true" class="" height="100vh" style="padding:0 ; margin:0; " />
    <div class="cardGrid" v-else>
		<div class="row py-5"> 
			<!-- <div class="storeLoader" v-if="storeLoader == true"> -->
				<!-- <loading-icon class="loading-icon" name="ball-clip-rotate-multiple" color="#fff" scale="1"></loading-icon> -->
			<!-- </div> -->
			<div class="col-md-3 col-sm-4 col-4 small-3" v-for="(item, i) in nearestStores"
				:key="i"
				@click="storePopUpHandler(item.all_stores)" >
				<Card :item="item" />
			</div>
		</div>
        <div
			class="modal"
			v-bind:class="{ active: isStorePopUp == true }"
			id="coupon-modal"
			v-if="isStorePopUp"
		>
			<div class="modal-dialog listStorePopup">
				<div class="modal-content">
					<div class="modal-body">
						<!-- class="close" -->
						<button
							type="button"
							class="close"
							@click="isStorePopUp = false"
							style="
                                margin-top: 0px;
                                margin-right: 15px;
                                z-index: 999;
                                top: 15px;
                                right: 0px;
                                font-size: 25px;
                            "
						>&times;</button>
						<div>
							<div class="storePopupHeading">
								<h3>{{popUpStores[0].name.replace(/"/g, '').split(",")[0]}}</h3>
								<small>{{ popUpStores.length }} Stores near you</small>
							</div>
							<div class="storeWrap" @click="isStorePopUp = false">
								<div class="row storePopupDetail">
									<div class="col-7">
										<strong>Address</strong>
									</div>
									<div class="col-2">
										<strong>Rating</strong>
									</div>
									<div class="col-3">
										<strong>Distance</strong>
									</div>
								</div>
								<div class="row storePopupData" v-for="(store, i) in popUpStores" :key="i">
									<router-link
										class="col-7 popuplink"
										:to="{ path: '/store.html', query: { store: store.id } }"
									>
										<div style="display: flex; justify-content: space-between">
										{{
											store.name
											.replace(/"/g, "")
											.substring(store.name.indexOf(",") + 1)
										}}
										<img
											v-if="store.express_store.is_express_delivery_available"
											height="25"
											src="/img/expressDelivery.png"
											alt="Express Delivery"
										/>
										</div>
									</router-link>
									<div class="col-2">
										<i class="fa fa-star"></i>
										{{ store.ratings.avg_rating }}
									</div>
									<div class="col-3">{{ Math.floor(store.distance) }} km</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
      
    </div>
</template>

<script> 
import axios from 'axios';
import Card from '../components/Home/Card.vue'
    export default {
        name: 'mobileBrand',
       components: { 
			Card, 
		},
        data(){
            return{
                nearestStores: [],
                popUpStores:[],
                isStorePopUp: false,
				storeLoader: true, 
            }
        },
        methods: {
            storePopUpHandler(stores) {
				console.log("stores", stores);
				this.popUpStores = stores;
				this.isStorePopUp = true;
			},
            getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
				var R = 6371; // Radius of the earth in km
				var dLat = this.deg2rad(lat2 - lat1); // this.deg2rad below
				var dLon = this.deg2rad(lon2 - lon1);
				var a =
					Math.sin(dLat / 2) * Math.sin(dLat / 2) +
					Math.cos(this.deg2rad(lat1)) *
						Math.cos(this.deg2rad(lat2)) *
						Math.sin(dLon / 2) *
						Math.sin(dLon / 2);
				var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
				var d = R * c; // Distance in km
				return d;
			},

			deg2rad(deg) {
				return deg * (Math.PI / 180);
			},
            getStores() {

                console.log("called");
				axios
					.get(this.$root.api_url + `/pim/pimresponse.php`, {
						params: {
							service: "category_stores", 
							categories: this.apiFilter, 
							// latitude: 28.5758268,
							// longitude: 77.3209443,
							latitude: this.$root.location.lat,
							longitude: this.$root.location.long,
						}
					})
					.then(response => { 
						
						if (!response.data.result) {
							this.nearestStores = [];

							this.isFilter = false; 
						}
						let stores = response.data.result;
						// console.log("storeoasudoasud", stores);
						for (let k = 0; k < stores.length; k++) {
							// console.log("stiredadd", stores[k]);
							// console.log(stores[k]);
							// for (let j = 0; j < stores[k].stores.length; j++) {
							// console.log(stores[k].stores[j]);
							let distance = this.getDistanceFromLatLonInKm(
								this.$root.location.lat,
								this.$root.location.long,

								// position.coords.latitude,
								// position.coords.longitude,
								stores[k].latitude,
								stores[k].longitude
							);
							stores[k].distance = distance.toFixed(2);
							if (stores[k].all_stores) {
								stores[k].all_stores.map((store, i) => {
									//   console.log(store);
									let distance = this.getDistanceFromLatLonInKm(
										this.$root.location.lat,
										this.$root.location.long,
										// position.coords.latitude,
										// position.coords.longitude,
										store.latitude,
										store.longitude
									);

									store.distance = distance.toFixed(2);
								});
							}

							// }
						}
						
						//   console.log(stores);
						this.nearestStores = stores;
						this.storeLoader = false;
						//   console.log("test",this.nearestStores);
						this.isFilter = false;
						// this.nearestStores = response.result
					})
					.catch(error => {});
			},
        },
        beforeMount(){
            this.getStores();
        }

    }
</script>
<style>
.storeLoader{
	width: 100%;
    display: inline-block;
    height: 250px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>